import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'preview-file-dialog',
    templateUrl: './preview-file-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PreviewFileDialogComponent {

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            file: any;
        },
        public dialogRef: MatDialogRef<PreviewFileDialogComponent>    ) { }

    closeDialog(result?: any) {
        this.dialogRef.close(result);
    }

}
